import { Navigate, useSearchParams } from "react-router-dom";
import { parseAmplifyConfig, parseQueryString, useAuth } from "@warden-ui/common";
import { clear } from "@warden-ui/common";
import { useEffect } from "react";

const defaultQueryString: {[key: string]: string} = {
  region: "",
  config: "",
  context: "",
}

export default function SignOut() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const amplifyConfig = parseAmplifyConfig(queryString);
  auth.configureAmplify(amplifyConfig);
  const redirectTarget = `/?${searchParams.toString()}`;

  useEffect(() => {
    async function signOut() {
      auth.configureAmplify(amplifyConfig);
      await auth.signOut(amplifyConfig);
      clear();
    }

    signOut();
  }, [auth, amplifyConfig, searchParams]);

  if (!auth.isSignedIn) {
    return <Navigate to={redirectTarget} replace={true}/>;
  }

  return null;
}
